module.exports = __webpack_public_path__ + "static/img/client-cost.508348b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/client-cost.png
// module id = J4cs
// module chunks = 1